import React, { useState } from 'react';
import { Button, Text } from '@ui';
import { translatorFor } from '../shared/i18n';
const t = translatorFor('recent_failures');
export function ReasonCell({ item }) {
    const [open, setOpen] = useState(false);
    return (React.createElement("div", null,
        React.createElement(Text, { variant: "body", as: "p" }, item.reason),
        item.detail && (React.createElement(React.Fragment, null,
            React.createElement(Button, { variant: "tertiary", onClick: () => setOpen((previous) => !previous) }, open ? t('hide_details') : t('show_details')),
            open && (React.createElement(Text, { variant: "x-small", as: "p", className: "service-titan-settings__detail" }, item.detail))))));
}
export function buildResendRenderer(onResend) {
    return function ResendCell({ item }) {
        return (React.createElement(Button, { variant: "secondary", onClick: () => onResend(item) }, t('resend')));
    };
}
